import React, { useState } from 'react';
import './PageCommon.css';
import './ConnectorsStock.css';

const connectors = [
  { id: 'CON-001', name: 'JST-XH 2.54mm', pins: 4, stock: 842, minStock: 100, supplier: 'JST Mfg', category: 'Signal', unit: 'pcs' },
  { id: 'CON-002', name: 'XT60 Power Connector', pins: 2, stock: 45, minStock: 50, supplier: 'Amass', category: 'Power', unit: 'pairs' },
  { id: 'CON-003', name: 'Molex MicroFit 3.0', pins: 8, stock: 312, minStock: 80, supplier: 'Molex', category: 'Signal', unit: 'pcs' },
  { id: 'CON-004', name: 'Anderson PP45', pins: 2, stock: 18, minStock: 30, supplier: 'Anderson Power', category: 'Power', unit: 'pairs' },
  { id: 'CON-005', name: 'D-Sub DE-9', pins: 9, stock: 156, minStock: 40, supplier: 'AMP/TE', category: 'Data', unit: 'pcs' },
  { id: 'CON-006', name: 'CAN Bus M12 4-pin', pins: 4, stock: 203, minStock: 60, supplier: 'Phoenix', category: 'Data', unit: 'pcs' },
];

const ConnectorsStock = () => {
  const [sortBy, setSortBy] = useState('id');

  const getStatus = (item) => {
    const ratio = item.stock / item.minStock;
    if (ratio < 0.5) return { label: 'Critical', cls: 'critical' };
    if (ratio < 1) return { label: 'Low', cls: 'low' };
    return { label: 'OK', cls: 'ok' };
  };

  const sorted = [...connectors].sort((a, b) => {
    if (sortBy === 'stock') return b.stock - a.stock;
    if (sortBy === 'name') return a.name.localeCompare(b.name);
    return a.id.localeCompare(b.id);
  });

  const totalStock = connectors.reduce((s, c) => s + c.stock, 0);
  const criticalCount = connectors.filter(c => getStatus(c).cls === 'critical').length;
  const lowCount = connectors.filter(c => getStatus(c).cls === 'low').length;

  return (
    <div className="page-wrapper">
      <div className="page-header">
        <div className="page-breadcrumb"><span>HOME</span><span className="sep">/</span><span className="current">CONNECTORS STOCK</span></div>
        <h1 className="page-title"><span className="page-icon">◈</span>Connectors Stock</h1>
        <p className="page-subtitle">Real-time inventory levels for connector components</p>
      </div>

      <div className="page-content">
        <div className="kpi-row">
          <div className="kpi-card">
            <span className="kpi-value">{totalStock.toLocaleString()}</span>
            <span className="kpi-label">TOTAL UNITS</span>
          </div>
          <div className="kpi-card">
            <span className="kpi-value">{connectors.length}</span>
            <span className="kpi-label">PART TYPES</span>
          </div>
          <div className="kpi-card alert">
            <span className="kpi-value">{criticalCount}</span>
            <span className="kpi-label">CRITICAL</span>
          </div>
          <div className="kpi-card warn">
            <span className="kpi-value">{lowCount}</span>
            <span className="kpi-label">LOW STOCK</span>
          </div>
        </div>

        <div className="toolbar">
          <div className="filter-group">
            <span className="filter-label">SORT BY:</span>
            {['id', 'name', 'stock'].map(s => (
              <button key={s} className={`filter-btn ${sortBy === s ? 'active' : ''}`} onClick={() => setSortBy(s)}>{s.toUpperCase()}</button>
            ))}
          </div>
        </div>

        <div className="connectors-list">
          {sorted.map(item => {
            const st = getStatus(item);
            const pct = Math.min(100, (item.stock / (item.minStock * 3)) * 100);
            return (
              <div key={item.id} className={`connector-card ${st.cls}`}>
                <div className="conn-left">
                  <div className="conn-id mono">{item.id}</div>
                  <div className="conn-name">{item.name}</div>
                  <div className="conn-meta">
                    <span className="meta-tag">{item.category}</span>
                    <span className="meta-tag">{item.pins}-PIN</span>
                    <span className="meta-tag">{item.supplier}</span>
                  </div>
                </div>
                <div className="conn-right">
                  <div className="stock-display">
                    <span className="stock-num">{item.stock.toLocaleString()}</span>
                    <span className="stock-unit">{item.unit}</span>
                  </div>
                  <div className="stock-bar-wrap">
                    <div className="stock-bar">
                      <div className="stock-fill" style={{ width: `${pct}%` }} />
                      <div className="stock-min-line" style={{ left: `${(1/3)*100}%` }} />
                    </div>
                    <span className="min-label">MIN: {item.minStock}</span>
                  </div>
                  <span className={`badge status-${st.cls}`}>{st.label}</span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ConnectorsStock;
